module.exports = __webpack_public_path__ + "static/media/input-loader-white.1349d5c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/input-loader-white.svg
// module id = 534
// module chunks = 0